<h2 mat-dialog-title>Material AI</h2>
<mat-dialog-content>
    <mat-checkbox [checked]="$result().generateDisplacement" (change)="$result.set({...$result(), generateDisplacement: $event.checked})">
        Generate displacement map
    </mat-checkbox>
    <mat-checkbox [checked]="$result().ignoreDpi" (change)="$result.set({...$result(), ignoreDpi: $event.checked})"> Ignore DPI </mat-checkbox>
    <mat-form-field>
        <mat-label>Filter radius (px)</mat-label>
        <input
            name="filterRadius"
            [ngModel]="$result().filterRadius"
            (ngModelChange)="$result.set({...$result(), filterRadius: $event})"
            matInput
            type="number"
        />
    </mat-form-field>
    <div>Tags:</div>
    <div>
        @for (tag of $result().tags; track $index) {
            <mat-chip-row (removed)="removeTag(tag)">
                {{ tagLabel(tag) }}
                <button matChipRemove>
                    <i class="far fa-times"></i>
                </button>
            </mat-chip-row>
        }
    </div>
    <mat-select name="addTag" (selectionChange)="addTag($event.value); $event.source.value = null" [placeholder]="'Add tag'">
        @for (tag of tagOptions; track tag[0]) {
            <mat-option [value]="tag[0]">{{ tag[1] }}</mat-option>
        }
    </mat-select>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancelAction()">Cancel</button>
    <button mat-button (click)="confirmAction()">Start</button>
</mat-dialog-actions>
